import React, { useEffect, useState } from "react";
import InternRequestTable from "../../Components/InternRequestTable";
import { matchOptions } from "../../utils/function";
import { optionsBranch } from "../../data/branch-data";
import { Container } from "@mui/material";

import { internType } from "../../data/interntype-data";
import CardInternship from "./CardInternship";
import useMediaQuery from '@material-ui/core/useMediaQuery';


const DashboardInternshipTab = ({ items = [], allStaff = [], textActive, setValue, value , onRefreshData  
 }) => {
  const [rowsData, setRowsData] = useState([]);
  const [excelDataSet, setExcelDataSet] = useState([]);
  const isMobile = useMediaQuery('(max-width:767px)');


  const onHandleItems = (items) => {
    console.log("onHandleItems", items);

    const rows = items.map((row) => {
      let dataJson;

      if (row.internLocation) {
        dataJson = JSON.parse(row?.internLocation?.manual_data);
      }

      return {
        req_id: row?.req_id,
        st_id: row?.st_id,
        name: `${row?.internStudent?.name}, ${matchOptions(
          optionsBranch,
          row?.internStudent?.b_id
        )}`,
        company: row?.company?.name,
        province: row?.company?.province,
        address: `${row.company.address} ${row.company.subdistrict}${row.company.district} ${row.company.province} ${row.company.zip}`,
        type_internship: matchOptions(internType, row.type_internship),
        intern_period: `${row.start_date} ถึง ${row.end_date}`,
        status: new Date(row?.start_date).getTime(),
        supervisor: row.supervisor,
        supervisor_name: allStaff.find((item) => item.id === row.supervisor)?.name,

        updated_at: "",
        form: row?.internLocation?.date_updated ?? "",
        internLocation_created: row?.internLocation?.date_created ?? "",
        start_date: row.start_date,
        end_date: row.end_date,
        b_id: row?.internStudent?.b_id,

        addressIntern: dataJson
          ? `${dataJson?.company.address.no} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? "แขวง"
                : "ต."
            }` +
            `${dataJson?.company.address.sub_district} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? "เขต"
                : "อ."
            }` +
            `${dataJson?.company.address.district} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? " "
                : "จ."
            }${dataJson?.company.address.province}` +
            ` ${dataJson?.company.address.postcode}`
          : `${row.company.address} ${
              row.company.province.includes("กรุงเทพ") ? "แขวง" : "ต."
            }` +
            `${row.company.subdistrict} ${
              row.company.province.includes("กรุงเทพ") ? "เขต" : "อ."
            }${row.company.district}` +
            ` ${row.company.province.includes("กรุงเทพ") ? "" : "จ."}${
              row.company.province
            } ${row.company.zip}`,

        addressUrl: dataJson?.location.link ?? "",

        auditorName: dataJson?.auditor.name ?? "",
        auditorPosition: dataJson?.auditor.position ?? "",
        auditorDepartment: dataJson?.auditor.department ?? "",
        auditorEmail: dataJson?.auditor.fax ?? "",
        auditorTel: dataJson?.auditor.tel ?? "",

        hrName: dataJson?.person.name ?? "",
        hrPosition: dataJson?.person.position ?? "",
        hrDepartment: dataJson?.person.department ?? "",
        hrEmail: dataJson?.person.email ?? "",
        hrTel: dataJson?.person.tel ?? "",

        jobDescription: dataJson?.job.desc ?? "",
        jobPosition: dataJson?.job.position ?? "",

        logbooklist: row?.doclogbook ?? "",
        internReport: row?.internReport,
        coopReport: row?.coopReport,
      };
    });

    //const sortData = rows.sort((a, b) => (a.st_id > b.st_id ? 1 : -1));

    const sortData = rows.sort((a, b) => (a.company > b.company ? 1 : -1));

    return sortData;
  };

  const onHandleExcel = (dataArr = []) => {
    const excelData = dataArr
      .filter((item) => +item.st_id && item.status != "0")
      .map((row) => {
        return {
          req_id: row?.req_id,
          st_id: row?.st_id,
          name: row?.name.split(", ")[0],
          branch: row?.name.split(", ")[1],
          supervisor: row?.supervisor_name,
          company: row?.company,
          address: row?.address,
          province: row?.province,
          //`${row.company.address} ${row.company.subdistrict} ${row.company.district} ${row.company.province} ${row.company.zip}`,
          type_internship: row?.type_internship,
          intern_period: `${row?.start_date} ถึง ${row?.end_date}`,
          form: row?.form,

          addressIntern: row?.addressIntern,
          addressUrl: row?.addressUrl,

          auditorName: row?.auditorName,
          auditorPosition: row?.auditorPosition,
          auditorDepartment: row?.auditorDepartment,
          auditorEmail: row?.auditorEmail,
          auditorTel: row?.auditorTel,

          hrName: row?.hrName,
          hrPosition: row?.hrPosition,
          hrDepartment: row?.hrDepartment,
          hrEmail: row?.hrEmail,
          hrTel: row?.hrTel,

          jobDescription: row?.jobDescription,
          jobPosition: row?.jobPosition,

          logbook1: row?.logbooklist[0]?.link,
        };
      });
    setExcelDataSet(excelData.sort((a, b) => (a.company > b.company ? 1 : -1)));
    console.log("excelData", excelData);

  };

  useEffect(() => {
    if (items.length) {
      //console.log("useEffect", items);
      const handleItem = onHandleItems(items);
      //console.log("handleItem", handleItem);
      setRowsData(handleItem);
      onHandleExcel(handleItem);
    }
  }, [items]);

  const headCells = [
    {
      id: "order",
      numeric: true,
      disablePadding: false,
      label: "#",
    },

    {
      id: "req_id",
      numeric: true,
      disablePadding: false,
      label: "Request ID	",
    },

    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "ชื่อ - สกุล	",
    },

    {
      id: "company",
      numeric: false,
      disablePadding: false,
      label: "สถานประกอบการ",
    },
    {
      id: "supervisor",
      numeric: false,
      disablePadding: false,
      label: "อาจารย์นิเทศ",
    },

    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "สถานะ",
    },
   
  ];

  return (
    <>
        <InternRequestTable
          textActive={textActive}
          tableColumn={headCells}
          tableData={rowsData}
          allStaff={allStaff}
          excelDataSet={excelDataSet}
          setValue={setValue}
          value={value}
          onRefreshData={onRefreshData}
          

        />
     
    </>
  );
};

export default DashboardInternshipTab;
